import { AsistenciaOfflineItem } from '../types/acreditacion.types';

const OFFLINE_QUEUE_KEY = 'congreso_acreditaciones_offline_queue';

export const offlineStorageService = {
  guardarLecturaOffline: (codigoQr: string, usuarioOperador: string): AsistenciaOfflineItem => {
    const cola = offlineStorageService.obtenerColaOffline();
    const nuevoItem: AsistenciaOfflineItem = {
      id: `${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
      codigoQr: codigoQr.trim(),
      fechaLectura: new Date().toISOString(),
      usuarioOperador: usuarioOperador || 'OperadorLocal'
    };

    cola.push(nuevoItem);
    localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(cola));
    return nuevoItem;
  },

  obtenerColaOffline: (): AsistenciaOfflineItem[] => {
    try {
      const data = localStorage.getItem(OFFLINE_QUEUE_KEY);
      if (!data) return [];
      return JSON.parse(data) as AsistenciaOfflineItem[];
    } catch {
      return [];
    }
  },

  limpiarColaOffline: (): void => {
    localStorage.removeItem(OFFLINE_QUEUE_KEY);
  },

  eliminarLecturaOffline: (id: string): void => {
    const cola = offlineStorageService.obtenerColaOffline();
    const filtrada = cola.filter(item => item.id !== id);
    localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(filtrada));
  }
};
